import { localeService } from '../../core';
const validateSignInForm = (values) => {
    const errors = {};
    if (values.shouldShowCaptcha && !values.recaptcha) {
        errors.recaptcha = localeService.formatMessageById('validation.captchaError"');
    }
    if (!values.password) {
        errors.password = localeService.formatMessageById('validation.signUp.missingPassword');
    }
    if (!values.email) {
        errors.email = localeService.formatMessageById('validation.signUp.missingEmail');
    }
    else if (!/^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i.test(values.email)) {
        errors.email = localeService.formatMessageById('validation.invalidEmail');
    }
    return errors;
};
export default validateSignInForm;
